export const BASE_URL = `https://backendportolio-production.up.railway.app`;

//export const BASE_URL = `http://localhost:3002`;
